<template>
  <component
    :is="previewComponent"
    v-if="previewComponent"
    :src="fileUrl"
    style="height: 100vh"
    @rendered="renderedHandler"
    @error="errorHandler"
  />
  <div v-else-if="loading" class="file-preview-status">
    文件加载中...
  </div>
  <div v-else class="file-preview-status">
    {{ errorMessage || "暂不支持该文件类型预览" }}
  </div>
</template>

<script setup>
import { markRaw, ref, watch } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();

const fileUrl = ref('');
const fileType = ref('');
const previewComponent = ref(null);
const loading = ref(false);
const errorMessage = ref('');

const officePreviewLoaderMap = {
  pdf: () => import(/* webpackChunkName: "office-pdf-preview", webpackPrefetch: false */ '@vue-office/pdf'),
  word: () => import(/* webpackChunkName: "office-word-preview", webpackPrefetch: false */ '@vue-office/docx'),
  excel: () => import(/* webpackChunkName: "office-excel-preview", webpackPrefetch: false */ '@vue-office/excel')
};

const loadPreviewComponent = async (type) => {
  const loader = officePreviewLoaderMap[type];

  previewComponent.value = null;
  errorMessage.value = '';

  if (!loader) {
    return;
  }

  loading.value = true;

  try {
    const module = await loader();
    previewComponent.value = markRaw(module.default || module);
  } catch (error) {
    console.error('文件预览组件加载失败:', error);
    errorMessage.value = '文件预览组件加载失败，请稍后重试';
  } finally {
    loading.value = false;
  }
};

watch(
  () => [route.query.fileUrl, route.query.fileType],
  async ([nextFileUrl, nextFileType]) => {
    fileUrl.value = String(nextFileUrl || '');
    fileType.value = String(nextFileType || '');
    await loadPreviewComponent(fileType.value);
  },
  { immediate: true }
);

const renderedHandler = () => {
  console.log('渲染完成');
};

const errorHandler = () => {
  console.log('渲染错误');
};
</script>

<style scoped>
.file-preview-status {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  color: #606266;
  font-size: 14px;
}
</style>
